import Swiper, { Autoplay, EffectFade } from 'swiper';

import '../sass/hero-bubble.scss';

const noMotionPreference = window.matchMedia('(prefers-reduced-motion: no-preference)');

(() => {
    const $homeHeros = document.querySelectorAll('.hero-bubble');

    if (!$homeHeros) return;

    $homeHeros.forEach($homeHero => {
        const $mediaVideoSource = $homeHero.querySelector('.hero-bubble__media-video-source');
        const $mediaVideoCanvases = $homeHero.querySelectorAll('.hero-bubble__media-video-canvas');
        const $mediaLarge = $homeHero.querySelector('.hero-bubble__media--large');
        const $mediaSmall = $homeHero.querySelector('.hero-bubble__media--small');
        const $mediaInnerLarge = $mediaLarge.querySelector('.hero-bubble__media-inner');
        const $mediaInnerSmall = $mediaSmall.querySelector('.hero-bubble__media-inner');
        const $mediaSliders = $homeHero.querySelectorAll('.hero-bubble__media-slider');

        const xTransformValue = 30;
        const xTransformValueHalf = xTransformValue / 2;
        const xTransformValueDouble = xTransformValue * 2;

        const yTransformValue = 20;
        const yTransformValueHalf = yTransformValue / 2;
        const yTransformValueDouble = yTransformValue * 2;

        const initSliders = () => {
            if (!$mediaSliders) return;

            $mediaSliders.forEach($slider => {
                const $sliderSlides = $slider?.querySelectorAll('.swiper-slide');

                if (!$slider || !$sliderSlides || $sliderSlides?.length < 2) return;

                new Swiper($slider, {
                    modules: [ Autoplay, EffectFade ],
                    autoplay: {
                        delay: 3000,
                        disableOnInteraction: false,
                    },
                    loop: true,
                    effect: 'fade',
                    fadeEffect: {
                        crossFade: true
                    },
                    allowTouchMove: false,
                });
            });
        };

        const initCircleHover = e => {
            requestAnimationFrame(() => {
                const rect = $homeHero.getBoundingClientRect();
            
                const x = e.clientX - window.scrollX - rect.left;
                const y = e.clientY - window.scrollY - rect.top;

                const largeXPosition = Math.round(xTransformValue *  (x / window.innerWidth) - xTransformValueHalf);
                const largeYPosition = Math.round(yTransformValue * (y / window.innerHeight) - yTransformValueHalf);

                const smallXPosition = Math.round(xTransformValueDouble *  (x / window.innerWidth) - xTransformValue);
                const smallYPosition = Math.round(yTransformValueDouble * (y / window.innerHeight) - yTransformValue);

                if ($mediaLarge) $mediaLarge.style.transform = `translate(${largeXPosition}px, ${largeYPosition}px)`;
                if ($mediaInnerLarge) $mediaInnerLarge.style.transform = `translate(${-largeXPosition}px, ${-largeYPosition}px)`;
                if ($mediaSmall) $mediaSmall.style.transform = `translate(${smallXPosition}px, ${smallYPosition}px)`;
                if ($mediaInnerSmall) $mediaInnerSmall.style.transform = `translate(${-smallXPosition}px, ${-smallYPosition}px)`;
            });
        };

        const initSyncedVideos = () => {
            if (!$mediaVideoSource || !$mediaVideoCanvases) return;

            const paintVideoFrame = () => {
                $mediaVideoCanvases.forEach($canvas => {
                    $canvas.getContext('2d', { alpha: false }).drawImage($mediaVideoSource, 0, 0, 1166, 656);
                });

                window.requestAnimationFrame(paintVideoFrame);
            }

            $mediaVideoSource.addEventListener('play', () => {
                window.requestAnimationFrame(paintVideoFrame);
            });

            window.addEventListener('load', () => {
                if (!noMotionPreference.matches) return;

                $mediaVideoSource.play();
            });
        };

        window.addEventListener('mousemove', e => {
            initCircleHover(e);
        });

        initSyncedVideos();
        initSliders();
    });
})();
